const {registerModule} = window;

class SecondaryNav {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  bindEvents() {
    this.ui.$toggleOverflow.addEventListener('click', this.handleToggle.bind(this) );
  }

  bindIntersectionObservers() {
    const options = {
      root: this.ui.$list,
      threshold: 1.0,
    };

    const observer = new IntersectionObserver((entries) => {
      this.isOverflowed = false;

      entries.forEach((entry) => {
        entry.target.dataset.isVisible = entry.isIntersecting;
      });

      this.isOverflowed = this.ui.$list.querySelectorAll('[data-is-visible="false"]').length > 0;
      this.updateUI();
    }, options);


    this.ui.$listItems.forEach(($listItem) => {
      observer.observe($listItem);
    });
  }

  bindUI() {
    this.ui = {};
    this.ui.$list = this.element.querySelector('[data-ref="list"]');
    this.ui.$listItems = this.ui.$list.querySelectorAll('li');
    this.ui.$toggleOverflow = this.element.querySelector('[data-ref="toggle-overflow"]');
    this.ui.$toggleOverflowLabel = this.element.querySelector('[data-ref="toggle-overflow-label"]');
  }

  handleToggle() {
    this.isCollapsed = !this.isCollapsed;
    this.updateUI();
  }

  initialize() {
    this.bindUI();
    this.setVars();
    this.bindIntersectionObservers();
    this.bindEvents();
  }

  updateUI() {
    this.element.dataset.isCollapsed = this.isCollapsed;
    this.element.dataset.isOverflowed = this.isOverflowed;

    this.ui.$toggleOverflowLabel.innerText = this.isCollapsed ? 'Show More' : 'Show Less';
  }

  setVars() {
    this.isCollapsed = this.element.dataset.isCollapsed === 'true';
    this.isOverflowed = false;
  }
}

registerModule('SecondaryNav', SecondaryNav);
